import EditBillingPeriodFormDto from 'types/PrpTable/dto/EditBillingPeriodFormDto';
import EditBillingPeriodDto from 'types/PrpTable/dto/EditBillingPeriodDto';

const mapToBillingDto = (data: EditBillingPeriodFormDto): EditBillingPeriodDto => {
  return {
    billingPeriodLength: data.amount ?? null
  } as EditBillingPeriodDto;
};
export default mapToBillingDto;
